import { ACCOUNT_TYPES } from 'common/constants/account.constants';

const makeAccountFullName = (item) =>
  `${item.accountInfo.name} ${item.accountNumber}`;
export const getCurrency = {
  USD: '$',
  EUR: '€',
};

export const validateMasterAccountForm = ({ key, value }) => {
  if (key === 'commission') {
    if (value >= 100) {
      value = 100;
    } else if (value < 0) {
      value = 0;
    }
  }
  return Number(
    value
      .toString()
      ?.replace(/[^0-9]/g, '')
      ?.replace('%', '')
  );
};

const V1_SHAPE = {
  account_id: 6928,
  account: '48891',
  name: 'Name',
  group: '',
  account_type_info: {
    account_type: 'forex_demo',
    is_trading: false,
    currency: ['USD'],
    leverage: [2, 10, 20, 55, 88, 100, 200, 400, 600, 800, 888, 1000, 2000],
  },
  server_info: {
    type: 'MT5',
    provider: 'mt5_trial1',
    terminal_host: '',
    terminal_port: 443,
    has_streaming: true,
    name: 'Base',
  },
  psp_info: null,
  leverage: 100,
  balance: 765.86,
  equity: 944.9,
  margin: 88.88,
  free_margin: 856.02,
  swap: 0,
  archived: false,
  read_only: false,
  enable: true,
  is_swap_free: false,
  is_trading: false,
  bonus: 0,
  deposit: 1000,
  withdraw: 0,
  negative_balance_compensation: 0,
  profit: -234.14,
  role: 'default',
};

const transformv2AccountToV1 = (account, type) => {
  const normalizedAccount = { ...V1_SHAPE, ...account };
  let accountType = null;

  const role = type.split('-mt5')[0];
  const isReal = !type.includes('demo');

  switch (role) {
    case 'demo':
      accountType = ACCOUNT_TYPES.forexDemo;
      break;
    case 'default':
      accountType = ACCOUNT_TYPES.forexReal;
      break;
    case 'master':
      accountType = ACCOUNT_TYPES.masterReal;
      break;
    case 'investor':
      accountType = ACCOUNT_TYPES.investorReal;
      break;
    case 'commission':
      accountType = ACCOUNT_TYPES.commissionReal;
      break;
    default:
      accountType = '';
      break;
  }

  normalizedAccount.account_type_info = {
    account_type: accountType,
    is_trading: isReal,
    currency: ['USD'],
    leverage: [],
  };
  normalizedAccount.account = account.login;
  normalizedAccount.free_margin = account.margin_free;
  normalizedAccount.enable = account.is_enable;
  normalizedAccount.is_trading = isReal;
  normalizedAccount.role = role;
  normalizedAccount.profit = account.equity - account.balance;
  normalizedAccount.account_type = accountType;

  return normalizedAccount;
};

export const AccountUtils = { makeAccountFullName, transformv2AccountToV1 };
